import { Show, createEffect, type JSX } from 'solid-js';
import Loading from './Loading';
import {
  createFleetSourcesReadyMemo,
  ensureFleetSourcesContextReady,
} from '../../utils/fleetSourcesReady';
import { persistantStore } from '../../store/persistantStore';

export interface FleetSourcesGateProps {
  children: JSX.Element;
  message?: string;
  fullScreen?: boolean;
}

/** Blocks fleet page content until sources catalog and selectedSources hydration are ready. */
export default function FleetSourcesGate(props: FleetSourcesGateProps) {
  const fleetSourcesReady = createFleetSourcesReadyMemo();

  createEffect(() => {
    if (fleetSourcesReady()) {return;}
    const className = persistantStore.selectedClassName();
    const projectId = persistantStore.selectedProjectId();
    void ensureFleetSourcesContextReady({ className, projectId });
  });

  return (
    <Show
      when={fleetSourcesReady()}
      fallback={
        <Loading
          message={props.message ?? 'Loading fleet sources...'}
          fullScreen={props.fullScreen ?? false}
        />
      }
    >
      {props.children}
    </Show>
  );
}
